import FeatureService from '../api/feature-service'

export default {
    namespaced: true,
    state: {
        features: []
    },
    mutations: {
        setFeatures (state, features) {
            state.features = features
        }
    },
    actions: {
        async setFeatures (context) {
            const response = await FeatureService.getFeatures()
            context.commit('setFeatures', response.data)
        }
    },
    getters: {
        getFeatureActiveByName: state => (name) => {
            const feature = state.features.find(f => f.name === name)
            return feature !== undefined ? feature.active : false
        }
    }
}
